export default __webpack_public_path__ + "static/media/img-c-00-bg-gtl.81c4fb51.jpg";